import { Box } from "@chakra-ui/react";

const AirportIcon = ({ color = "white", bgColor = "#28292B", ...props }) => {
  return (
    <Box {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="20" height="20" rx="10" fill={bgColor} />
        <path
          d="M8.67289 15.8245L7.09287 12.8879L4.15625 11.3079L5.2894 10.1907L7.60358 10.5897L9.23149 8.96179L4.17221 6.80721L5.51284 5.43466L11.6574 6.51993L13.6364 4.54091C13.8811 4.29619 14.1844 4.17383 14.5461 4.17383C14.9079 4.17383 15.2111 4.29619 15.4558 4.54091C15.7006 4.78562 15.8229 5.0862 15.8229 5.44264C15.8229 5.79908 15.7006 6.09965 15.4558 6.34437L13.4609 8.33935L14.5461 14.4679L13.1895 15.8245L11.019 10.7653L9.39109 12.3932L9.80604 14.6914L8.67289 15.8245Z"
          fill={color}
        />
      </svg>
    </Box>
  );
};

export default AirportIcon;
